import { CurrencyCodeType } from '@/types/currency';
import { isCurrencyCodeType } from '@/types/currency.ext';
import { Locale } from '@/types/locale';
import { formatAmount, FormatStyle } from '@/utility/formatAmount';
export interface Amount {
  readonly currencyCode: CurrencyCodeType;
  readonly value: number | null;
}

export class Amount {
  public static format(
    locale: Locale,
    amount: Amount,
    formatStyle: FormatStyle = FormatStyle.extended,
    displayUsdcAsUsd: boolean = false,
  ): string {
    return formatAmount(
      locale,
      amount.value,
      amount.currencyCode,
      formatStyle,
      2,
      displayUsdcAsUsd,
    );
  }

  public static zero(currencyCode: CurrencyCodeType): Amount {
    return {
      currencyCode: currencyCode,
      value: 0,
    };
  }
}

export const isAmount = (something: unknown): something is Amount => {
  return (
    typeof something === 'object' &&
    something !== null &&
    'currencyCode' in something &&
    isCurrencyCodeType(something.currencyCode) &&
    'value' in something
  );
};
